import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AllocationAndReceivingRunningBalanceRoutingModule } from './allocation-and-receiving-running-balance-routing.module';
import { AllocationAndReceivingRunningBalanceComponent } from './allocation-and-receiving-running-balance.component';
import { AllocationAndReceivingRunningBalanceFilterComponent } from './allocation-and-receiving-running-balance-filter/allocation-and-receiving-running-balance-filter.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { ReportModule } from "../report.module";

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    AllocationAndReceivingRunningBalanceRoutingModule,
    ReportModule
],
  declarations: [AllocationAndReceivingRunningBalanceComponent, AllocationAndReceivingRunningBalanceFilterComponent],
  entryComponents:[AllocationAndReceivingRunningBalanceFilterComponent]
})
export class AllocationAndReceivingRunningBalanceModule { }
